<template>
  <div>
    <v-menu offset-y left min-width="210">
      <template v-slot:activator="{ on, attrs }">
        <div
          class="user-menu__trigger d-flex align-center"
          v-on="on"
          v-bind="attrs"
        >
          <user-avatar :record-id="userId" :size="32" disable-tooltip />
          <v-icon x-small class="ml-1 text--secondary">fa-chevron-down</v-icon>
        </div>
      </template>

      <v-list dense>
        <v-list-item
          v-for="route in settingsRoutes"
          :key="route.name"
          :to="{ name: route.name }"
        >
          <v-list-item-icon>
            <v-icon small>{{ route.meta.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ route.meta.name || route.name }}</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2" />

        <v-list-item @click="toggleTheme">
          <v-list-item-icon>
            <v-icon small>{{ themeIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ themeText }}</v-list-item-title>
        </v-list-item>

        <v-list-item @click="dialog = true">
          <v-list-item-icon>
            <v-icon small>fa-solid fa-arrow-right-from-bracket</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Log Out</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog v-model="dialog" max-width="360">
      <v-card>
        <v-card-title class="text-h6">Log out?</v-card-title>
        <v-card-text>Are you sure you want to log out?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" depressed @click="logout">Log Out</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UserAvatar from './UserAvatar.vue'
import { routes } from '@/router'

export default {
  components: {
    UserAvatar
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    userId () {
      return this.$store.getters.user?.id
    },
    // The settings section's routes, exactly as the side nav lists them.
    settingsRoutes () {
      return routes.filter(route =>
        route.meta &&
        route.meta.nav === 'settings' &&
        !route.meta.hidden &&
        (
          !route.meta.roles ||
          !route.meta.roles.length ||
          route.meta.roles.some(role => this.$hasRole(role))
        )
      )
    },
    themeIcon () {
      return this.$vuetify.theme.dark ? 'fas fa-sun' : 'fas fa-moon'
    },
    themeText () {
      return this.$vuetify.theme.dark ? 'Light Mode' : 'Dark Mode'
    }
  },
  methods: {
    toggleTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      window.localStorage.setItem('darkMode', !!this.$vuetify.theme.dark)
    },
    async logout () {
      this.dialog = false
      try {
        document.body.style.opacity = 0.3
        await this.$store.dispatch('endSession')
      } finally {
        document.body.style.opacity = 1
      }
    }
  }
}
</script>

<style scoped>
.user-menu__trigger {
  cursor: pointer;
}
</style>
